import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "../Common/FormElements/Select/Select";
import { getAffiliates } from "../../REDUX/actions/affiliate";
import { setAppCustomersScope } from "../../REDUX/actions/appCustomers";
import { usePartnerOrganizations } from "./usePartnerOrganizations";

/**
 * Espace clients scope: admin filters by business affiliate and/or store,
 * a business affiliate by one of its stores; a reseller sees nothing here
 * (the server pins its own store). Every tab's fetch sends the scope.
 */
const CustomerSpaceFilters = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { isAdmin, isAffiliate, optionsForAffiliate } = usePartnerOrganizations();
  const { affiliates } = useSelector((state) => state.affiliateReducer);
  const { scope } = useSelector((state) => state.appCustomersReducer);

  useEffect(() => {
    if (!isAdmin) return;
    const controller = new AbortController();
    dispatch(getAffiliates(controller.signal));
    return () => controller.abort();
  }, [dispatch, isAdmin]);

  if (!isAdmin && !isAffiliate) return null;

  const affiliateOptions = (affiliates ?? []).map((affiliate) => ({
    name: affiliate?.attributes?.company || `#${affiliate?.id}`,
    code: affiliate?.id,
  }));
  // Picking an affiliate narrows the store list to the stores it sponsors.
  const organizationOptions = optionsForAffiliate(scope.businessAffiliateId);
  const selected = (options, id) =>
    options.find((option) => option.code === id) ?? null;

  return (
    <div className="d-flex flex-wrap gap-3">
      {isAdmin ? (
        <div style={{ minWidth: 280 }}>
          <p className="f14 text-brightGrey mb-1">{t("Business affiliate")}</p>
          <Select
            name="businessAffiliateId"
            value={selected(affiliateOptions, scope.businessAffiliateId)}
            options={affiliateOptions}
            callback={(e) =>
              dispatch(
                setAppCustomersScope({
                  businessAffiliateId: e.value?.code ?? null,
                  organizationId: null,
                })
              )
            }
            placeholder={t("All")}
            filter
            showClear
            resetable
          />
        </div>
      ) : null}
      <div style={{ minWidth: 280 }}>
        <p className="f14 text-brightGrey mb-1">{t("Reseller")}</p>
        <Select
          name="organizationId"
          value={selected(organizationOptions, scope.organizationId)}
          options={organizationOptions}
          callback={(e) =>
            dispatch(setAppCustomersScope({ organizationId: e.value?.code ?? null }))
          }
          placeholder={t("All")}
          filter
          showClear
          resetable
        />
      </div>
    </div>
  );
};

export default CustomerSpaceFilters;
